export var FormStatus;

(function (FormStatus) {
  FormStatus["Active"] = "active";
  FormStatus["Processing"] = "in-processing";
  FormStatus["Error"] = "error";
})(FormStatus || (FormStatus = {}));